import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export interface InlineFieldProps {
  children: React.ReactNode;
  className?: string;
  label: string;
}

export default function InlineField({children, className, label}: InlineFieldProps): JSX.Element {
  return (
    <div className={classNames('inlineField', className)}>
      <strong className="u-small-spacing-right">{label}</strong>
      {children}
    </div>
  );
}

InlineField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
};
